package kotlinReactComponents

import BaseLayoutStyles
import javaScriptImport.LineChartJs2
import javaScriptImport.chartJsAuto
import react.Props
import react.fc
import styled.css
import styled.styledDiv


class SprintChartClass {
    companion object {
        val fullDataRealSprint: Array<Int> = arrayOf(63, 61, 54, 48, 40, 40, 40, 50, 42, 38, 33, 37, 35, 27)
        val fullDataPlannedSprint: Array<Int> = arrayOf(63, 56, 49, 42, 35, 35, 35, 28, 21, 14, 7, 0)
        val xAxisDays: Array<String> = arrayOf(
            "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag",
            "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"
        )
        //                val currentDataRealSprint : MutableList<Int> = mutableListOf()
        val currentDataRealSprint: MutableList<Int> = mutableListOf()

        val realDataMap = mapOf<Array<String>, Array<Int>>(xAxisDays to fullDataRealSprint)
        val plannedDataMap = mapOf<Array<String>, Array<Int>>(xAxisDays to fullDataPlannedSprint)

    }

}


val sprintChart =  fc<Props>("Chart") {
    val _ensureChartJs = chartJsAuto

    styledDiv {
        css {

        }

        styledDiv {
            css {
                +BaseLayoutStyles.gradientBackground
                +BaseLayoutStyles.whiteLetters
                +BaseLayoutStyles.alignContentAtCenter
                +BaseLayoutStyles.alignItemsCenter
                +BaseLayoutStyles.alignSelfCenter
                +BaseLayoutStyles.alignTextCenter
                +BaseLayoutStyles.fullWidth
                +BaseLayoutStyles.chartHeight
            }

            // Chart parameters
            val data = js("{}")
            data.labels = SprintChartClass.xAxisDays

            val real = js("{}")
            real.label = "Real Sprint"
            real.data = SprintChartClass.fullDataRealSprint
            real.borderColor = "rgb(175,0,0)"
            real.backgroundColor = "rgba(255,255,255,0.99)"
            real.tension = 0.25

            val planned = js("{}")
            planned.label = "Planned Sprint"
            planned.data = SprintChartClass.fullDataPlannedSprint
            planned.borderColor = "rgb(112,255,0)"
            planned.backgroundColor = "rgba(0,160,0,0.15)"
            planned.borderDash = arrayOf(6, 6)
            planned.tension = 0.0

            data.datasets = arrayOf(real, planned)

            val options = js("{}")
            options.responsive = true
            options.maintainAspectRatio = false

            options.plugins = js("{}")
            options.plugins.legend = js("{}")
            options.plugins.legend.labels = js("{}")
            options.plugins.legend.labels.color = "#ffffff"
            options.plugins.legend.position = "top"
            options.plugins.title = js("{}")
            options.plugins.title.display = true
            options.plugins.title.text = "Sprint Burndown"
            options.plugins.title.color = "rgb(0,0,0)"

            options.scales = js("{}")
            options.scales.x = js("{}")
            options.scales.y = js("{}")

            options.scales.x.ticks = js("{}")
            options.scales.x.ticks.color = "#000000"
            options.scales.y.ticks = js("{}")
            options.scales.y.ticks.color = "#ffffff"

            options.scales.x.grid = js("{}")
            options.scales.x.grid.color = "rgba(0,0,0,0.5)"
            options.scales.y.grid = js("{}")
            options.scales.y.grid.color = "rgba(255,255,255,0.75)"

            child(LineChartJs2) {
                attrs {
                    datasetIdKey = "label"
                    this.data = data
                    this.options = options
                }
            }
        }

        styledDiv {
            css {
            }

        }
    }
}


